import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m25.195 13.882-1.12 1.12v7.675a2 2 0 0 1-.595 1.395l-4.036 4.048a2 2 0 0 1-3.375-1.024l-.99-4.94-5.235-5.235-4.94-.99a2 2 0 0 1-1.523-1.38 2 2 0 0 1 .499-1.995l.001-.002L7.928 8.52a2 2 0 0 1 1.395-.595h7.675l1.12-1.12c3.491-3.491 7.05-3.49 8.646-3.258a1.975 1.975 0 0 1 1.689 1.689c.23 1.596.233 5.155-3.258 8.646m-5.663-5.663c2.924-2.924 5.781-2.86 6.942-2.693.167 1.16.23 4.018-2.694 6.942L16 20.248 11.752 16zm-4.534 1.706H9.352l-.009.008-4.048 4.036h.001l4.713.945zm2.088 12.066L22.075 17v5.647l-4.044 4.057z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M9.244 21.185a1 1 0 0 0-.638-1.895c-2.542.855-3.76 2.969-4.338 4.703a11.8 11.8 0 0 0-.58 3.291v.027l1 .001h-1a1 1 0 0 0 1 1v-1 1h.028a6 6 0 0 0 .27-.01 11.795 11.795 0 0 0 3.021-.571c1.734-.577 3.848-1.795 4.703-4.337a1 1 0 0 0-1.895-.638c-.57 1.695-1.993 2.596-3.44 3.078a9.7 9.7 0 0 1-1.586.376c.07-.457.186-1.01.377-1.585.482-1.447 1.383-2.87 3.078-3.44"
    />
  </svg>
);
const SvgIconRocketLaunch = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconRocketLaunch);
export default Memo;
